export default "__VITE_ASSET__BAbdZqVo__ 100w";